module.exports = {
        srcSet: __webpack_public_path__ + "static/media/digital_address-800.cb4d7da3.webp"+" 800w"+","+__webpack_public_path__ + "static/media/digital_address-866.d6e492ed.webp"+" 866w",
        images: [{path: __webpack_public_path__ + "static/media/digital_address-800.cb4d7da3.webp",width: 800,height: 533},{path: __webpack_public_path__ + "static/media/digital_address-866.d6e492ed.webp",width: 866,height: 577}],
        src: __webpack_public_path__ + "static/media/digital_address-866.d6e492ed.webp",
        toString: function(){return __webpack_public_path__ + "static/media/digital_address-866.d6e492ed.webp"},
        
        width: 866,
        height: 577
      }